
















































import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {User} from "@/types";
import {Component, Prop, Vue} from "vue-property-decorator";

import {mapGetters} from "vuex";

@Component({
    components: {
        Swiper,
        SwiperSlide,
    },
    computed: {...mapGetters(["user"])},
})
export default class UserSettingHeader extends Vue {
    private user!: User;
    VMswiperOption = {
        slidesPerView: 7,
        spaceBetween: 0,
        breakpoints: {
            300: {
                slidesPerView: 4
            },
            480: {
                slidesPerView: 4
            },
            768: {
                slidesPerView: 5.5
            },
            992: {
                slidesPerView: 7
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }

    async mounted(){
        await this.$store.dispatch('loginState')
    }
}
